/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import envConfig from '../../../envConfig';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';
import { CrudType } from '../../../utility/types/CrudType';
import { CrudStatus } from '../../../utility/types/CrudStatus';

const selectAlertEventsError = (state) => state.selectedAlertEvents.error;
const selectSelectedAlertEventsHasNextPage = (state) => state.selectedAlertEvents.hasNextPage;
const selectPagedAlertEventList = (state) => state.selectedAlertEvents.pagedAlertEventList;
const selectTotalNumRecords = (state) => state.selectedAlertEvents.totalNumRecords;
const selectAlertEventsLoading = (state) => state.selectedAlertEvents.loading;

const fetchAlertEventListNextPage = createAsyncThunk(
  'securedApi/alertEvents/fetchAlertEvents',
  async (_, thunkAPI) => {
    try {
      const selectedAlertEventSlice = thunkAPI.getState().selectedAlertEvents;
      const selectedAlert = thunkAPI.getState().singleAlert.alert;
      const { currPage } = selectedAlertEventSlice;
      return await RaaAuthenticatedRemoteService
        .globalInstance()
        .get(`${envConfig.apiUrl}/api/v2/alert-event/history/alert/transport-counts?id=${selectedAlert.id}&pageNo=${currPage}&pageSize=${10}`);
    } catch (error) {
      return thunkAPI.rejectWithValue({
        name: error.name,
        message: error.message,
        data: error.data,
      });
    }
  },
);

export const alertEventsSlice = createSlice({
  name: 'selectedAlertEvents',
  initialState: {
    selectedAlertId: null,
    pagedAlertEventList: [],
    currPage: 0,
    hasNextPage: false,
    totalNumRecords: 0,
    crudOperation: CrudType.READ,
    crudStatus: CrudStatus.IDLE,
    error: false,
    loading: true,
  },
  reducers: {
    clearActiveAlertEventsSlice: () => ({
      selectedAlertId: null,
      pagedAlertEventList: [],
      currPage: 0,
      hasNextPage: false,
      totalNumRecords: 0,
      crudOperation: CrudType.READ,
      crudStatus: CrudStatus.IDLE,
      error: false,
      loading: true,
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlertEventListNextPage.pending, (state) => {
        state.loading = true;
        state.crudOperation = CrudType.READ;
        state.crudStatus = CrudStatus.PENDING;

        state.error = false;
      })
      .addCase(fetchAlertEventListNextPage.fulfilled, (state, action) => {
        const { alertEventList, pageInfo } = action.payload;
        if (alertEventList) {
          const updatedList = Array.from(new Set(
            [...state.pagedAlertEventList, ...alertEventList],
          ));
          state.currPage += 1;
          state.hasNextPage = pageInfo.hasNext;
          state.totalNumRecords = pageInfo.totalRecords;
          state.pagedAlertEventList = updatedList;
        }
        state.crudStatus = CrudStatus.SUCCESS;
        state.loading = false;
        state.error = false;
      })
      .addCase(fetchAlertEventListNextPage.rejected, (state) => {
        state.error = true;
        state.loading = false;
        state.crudStatus = CrudStatus.ERROR;
      });
  },
});

const { actions, reducer } = alertEventsSlice;
export const { clearActiveAlertEventsSlice } = actions;
export {
  fetchAlertEventListNextPage,
  selectSelectedAlertEventsHasNextPage,
  selectPagedAlertEventList, selectTotalNumRecords,
  selectAlertEventsLoading, selectAlertEventsError,
};

export default reducer;
